//ajax
import "./header/ajax/ajax-header-banners";
import "./header/header-banner";

import "./components/switches";
import "./components/shareCopyLink";
import "./components/block_smooth_scrolling";


///// PageSpeed Insights ///////

jQuery(function () {
    /// lazy Load GDPR plugin logo
    if (jQuery(".moove-gdpr-company-logo-holder img").length) {
        jQuery(".moove-gdpr-company-logo-holder img").attr("loading", "lazy");
    }

    /// GDPR plugin set button to 0 index
    if (jQuery(".moove-gdpr-infobar-allow-all").length) {
        jQuery(".moove-gdpr-infobar-allow-all").attr("tabindex", "0");
    }
});